import {useState} from 'react'

type FieldsItemProps = {
  field: Record<string, any>
  onChange?: (key: string, filterable: boolean) => void
}

export function FieldsItem({field, onChange}: FieldsItemProps) {
  const [currentField, setCurrentField] = useState<Record<string, any>>(field)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentField({...currentField, filterable: e.target.checked})
    onChange?.(field.key, e.target.checked)
  }

  return (
    <div className='mt-2'>
      <div className='form-check form-check-custom form-check-solid mb-3'>
        <input
          className='form-check-input'
          type='checkbox'
          id={`checkFilterableField_${field.key}`}
          checked={currentField.filterable}
          onChange={handleChange}
          disabled={currentField.filter_type.includes('none')}
        />
        <label className='form-check-label' htmlFor={`checkFilterableField_${field.key}`}>
          <div className='d-flex align-items-center'>
            <span>{currentField.label}</span>
            <code className='fs-9'>{currentField.filter_type}</code>
            <code className='fs-9'>{currentField.key}</code>
          </div>
          <span className='d-block text-muted fs-9'>{currentField.description}</span>
        </label>
      </div>
    </div>
  )
}
